import { FunctionComponent } from "react";

import UserIconAlt from "@ui/components/icon/UserIconAlt";
import SubscribeNav from "@ui/components/navigation/Navigation/components/PrimaryNavigation/components/PrimaryNavigationStandard/components/SubscribeNav/SubscribeNav";
import { VergeNavigationVariants } from "@ui/components/navigation/Navigation/Navigation";

import * as styles from "./VergeSubscribeNav.css";

type Props = {
  variant: VergeNavigationVariants;
  hideAccountLink?: boolean;
};

const VergeSubscribeNav: FunctionComponent<Props> = ({
  variant = "standard",
  hideAccountLink = false,
}) => {
  return (
    <SubscribeNav
      subscribeStyles={styles.subscribeButton[variant]}
      linkStyles={styles.link[variant]}
      subscribeText="Subscribe"
      hideAccountLink={hideAccountLink}
      leftIcon={
        <UserIconAlt width={8} height={14} className={styles.icon[variant]} />
      }
    />
  );
};

export default VergeSubscribeNav;
